import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminPage from "@/pages/AdminPage";
import GaleriasPage from "@/pages/GaleriasPage";
import AlbumPage from "@/pages/AlbumPage";
import PlantelPage from "@/pages/PlantelPage";
import RosterPage from "@/pages/RosterPage";
import PlayerPage from "@/pages/PlayerPage";
import NosotrosPage from "@/pages/NosotrosPage";
import HistoriaPage from "@/pages/HistoriaPage";
import PalmaresPage from "@/pages/PalmaresPage";
import ComisionPage from "@/pages/ComisionPage";
import EquiposPage from "@/pages/EquiposPage";
import MembresiasPage from "@/pages/MembresiasPage";
import TiendaPage from "@/pages/TiendaPage";
import PatrocinadoresPage from "@/pages/PatrocinadoresPage";
import SponsorProfilePage from "@/pages/SponsorProfilePage";
import AppsPage from "@/pages/AppsPage";
import NoticiasPage from "@/pages/NoticiasPage";
import PostPage from "@/pages/PostPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/nosotros" element={<NosotrosPage />} />
        <Route path="/historia" element={<HistoriaPage />} />
        <Route path="/palmares" element={<PalmaresPage />} />
        <Route path="/comision" element={<ComisionPage />} />
        <Route path="/equipos" element={<EquiposPage />} />
        <Route path="/membresias" element={<MembresiasPage />} />
        <Route path="/tienda" element={<TiendaPage />} />
        <Route path="/patrocinadores" element={<PatrocinadoresPage />} />
        <Route path="/patrocinadores/:slug" element={<SponsorProfilePage />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/noticias" element={<NoticiasPage />} />
        <Route path="/noticias/:slug" element={<PostPage />} />
        <Route path="/galerias" element={<GaleriasPage />} />
        <Route path="/galerias/:slug" element={<AlbumPage />} />
        <Route path="/plantel" element={<PlantelPage />} />
        <Route path="/plantel/:slug" element={<RosterPage />} />
        <Route path="/jugador/:slug" element={<PlayerPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
